import React from "react";
import styled from "@emotion/styled";

/**
 * Numero de version affiche discretement en bas de l'application.
 * La valeur vient du champ "version" de package.json, injecte dans
 * REACT_APP_VERSION par les scripts npm (cf. package.json).
 */
const AppVersion = () => {
  const version = process.env.REACT_APP_VERSION;

  // Les routes /widget/* sont des fragments embarques dans d'autres pages du
  // BO : pas de pied de page dedans.
  if (!version || window.location.pathname.startsWith("/widget")) return null;

  return <Version>Version {version}</Version>;
};

const Version = styled.div`
  padding: 1.5rem 0.75rem 1rem;
  text-align: center;
  font-size: 0.7rem;
  letter-spacing: 0.02em;
  color: ${(props) => props.theme?.colors?.grey || "#aaaaaa"};
  user-select: none;
`;

export default AppVersion;
